define('viewmodels/RiskRating/RiskRatingResponsePageOld',['knockout', 'plugins/router', 'services/appsecurity', 'services/navigation', 'durandal/app', 'services/logger', 'durandal/system', 'services/utils', 'viewmodels/RiskRating/RiskRatingDashboard'],
    function (ko, router, appsecurity, navigation, app, logger, system, utils, RiskRatingDashboard) {

        var RRResponseVM = {
            activate: activate,
            detached: detached,
            canActivate: ko.observable(true),
            attached: attached,
            appsecurity: appsecurity,
            PageHeaderName: ko.observable(),
            NavigateToDashboard: NavigateToDashboard,

            RoleId: ko.observable(),
            SurveyStatus: ko.observable(),
            SurveyProcessPoint: ko.observable(),
            ResponseMoveArray: ko.observable(),
            SurveyId: ko.observable(),
            SurveyName: ko.observable(),
            SurveyUsers: ko.observable(),
            DisableControl: ko.observable(false),
            RiskRatingDashboard: RiskRatingDashboard,

            // Survey
            SurveyData: ko.observableArray([]),
            SurveyDataDup: ko.observableArray([]),
            RespondersList: ko.observableArray([]),
            ReviewersList: ko.observableArray([]),

            ResetResponse: ResetResponse,
            SaveResponse: SaveResponse,
            ConditionQuestionchange: ConditionQuestionchange,

            // Search 
            SearchResult: SearchResult,
            SearchQuery: ko.observable(''),
            ClearSearchText: ClearSearchText,

            // Progress Bar
            BarWidth: ko.observable(0),
            ProgressBar: ProgressBar,

            //Comments
            ShowComments: ShowComments,
            SaveComment: SaveComment,
            ResetComment: ResetComment,
            EditComment: EditComment,
            CloseCommentsPopOver: CloseCommentsPopOver,
            RcKeypress: RcKeypress,
            RcKeyUp: RcKeyUp,
            CommentsList: ko.observableArray([]),
            ResponseComment: ko.observable(),
            ResponseCommentChars: ko.observable(),
            ResponseCommentCharsLimit: ko.observable(),
            SelectedQuestion: ko.observable(),
            ResponseTypesDropdown: ko.observableArray([]),
            SelectedResponseTypeId: ko.observable(),
            SelectedCommentId: ko.observable(''),

            SelectedQuestionId: ko.observable(),

            //Documents
            ShowUploadDocumentsPopUp: ShowUploadDocumentsPopUp,
            UploadDocument: UploadDocument,
            DeleteDocument: DeleteDocument,
            CloseDocumentsPopOver: CloseDocumentsPopOver,
            DownloadDocument: DownloadDocument,
            RdKeypress: RdKeypress,
            RdKeyUp: RdKeyUp,
            DocumentsList: ko.observableArray([]),
            QuestionDisplayRank: ko.observable(),
            SelectedQuestionText: ko.observable(),
            IsReadOnlyQuestion: ko.observable(),
            ProgressPercent: ko.observable(),
            ProgressMessage: ko.observable(),
            UploadDocCommentChars: ko.observable(),
            UploadDocCommentCharsLimit: ko.observable(),
            UploadComment: ko.observable(),
            UploadFileSize: ko.observable(),

            // Actions 
            FinalizeSurveyClick: FinalizeSurveyClick,
            btnClickPerformAction: btnClickPerformAction,
            SurveyActionsList: ko.observableArray([]),
            PushbackCommentCharsLimit: ko.observable(),
            PushbackCommentChars: ko.observable(),
            PbcKeypress: PbcKeypress,
            PbcKeyUp: PbcKeyUp,
            PushbackComment: ko.observable()

        };

        return RRResponseVM;

        function detached() {
            try {
                RRResponseVM.canActivate(true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: detached() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function activate() {
            try {
                if (RRResponseVM.RiskRatingDashboard.SelectedStatus() === undefined) {
                    RRResponseVM.canActivate(false);
                    router.navigate("#RiskRating/RiskRatingDashboard", true);
                    return false;
                } else {

                    ClearSearchText();
                    RRResponseVM.BarWidth(0);

                    RRResponseVM.SurveyStatus(RRResponseVM.RiskRatingDashboard.SelectedStatus());
                    RRResponseVM.ResponseMoveArray(RRResponseVM.RiskRatingDashboard.ResponseMoveArray());
                    RRResponseVM.SurveyId(RRResponseVM.RiskRatingDashboard.ResponseMoveArray().SurveyId());
                    RRResponseVM.SurveyName(RRResponseVM.RiskRatingDashboard.ResponseMoveArray().SurveyName());
                    RRResponseVM.SurveyUsers(RRResponseVM.RiskRatingDashboard.ResponseMoveArray().AssignedUserName());
                    RRResponseVM.SurveyProcessPoint(RRResponseVM.RiskRatingDashboard.ResponseMoveArray().ProcessPoint());
                }

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: activate() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function attached() {
            try {
                $('#loadingImgMain').show();
                if (RRResponseVM.RiskRatingDashboard.SelectedStatus() === undefined) {
                    RRResponseVM.canActivate(false);
                    router.navigate("#RiskRating/RiskRatingDashboard", true);
                    return false;

                } else {
                    if (RRResponseVM.appsecurity !== undefined && RRResponseVM.appsecurity.userInfo() !== undefined && RRResponseVM.appsecurity.userInfo().PrimaryRoleId() !== undefined) {
                        RRResponseVM.RoleId(RRResponseVM.appsecurity.userInfo().PrimaryRoleId());
                    }
                    RRResponseVM.canActivate(true);
                    RRResponseVM.PageHeaderName('Survey Questionnaire');
                    GetRRWorkFlowDetails();
                    GetCompleteSurveyData();
                    RRResponseVM.ResponseCommentCharsLimit(4000);
                    RRResponseVM.UploadDocCommentCharsLimit(1000);
                    RRResponseVM.PushbackCommentCharsLimit(1000);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: attached() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function NavigateToDashboard(data) {
            try {
                router.navigate('RiskRating/RiskRatingDashboard', true);
                $('#loadingImgforDashboard').hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: NavigateToDashboard() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#region SurveyData

        function GetRRWorkFlowDetails() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRWorkFlowDetails",
                    type: "GET",
                    data: { "SurveyId": RRResponseVM.SurveyId() },
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetRRWorkFlowDetails() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null) {
                        RRResponseVM.RespondersList(jsonResult.RespondersList);
                        RRResponseVM.ReviewersList(jsonResult.ReviewersList);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetRRWorkFlowDetails() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source: ajaxFail from GetRRWorkFlowDetails() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetRRWorkFlowDetails() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetCompleteSurveyData() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetCompleteSurveyData",
                    type: "GET",
                    data: { "SurveyId": RRResponseVM.SurveyId(), "RoleId": RRResponseVM.RoleId() },
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetCompleteSurveyData() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    if (jsonResult !== null) {
                        $('#loadingImgMain').hide();
                        if (jsonResult.length > 0) {
                            var mappedData = $.map(jsonResult, function (result) {
                                return new SurveyQuestionnaireModel(result);
                            });
                            $('#QuestionsDiv').show();
                            RRResponseVM.SurveyData(mappedData);
                            RRResponseVM.SurveyDataDup(mappedData);
                            RRResponseVM.BarWidth(mappedData[0].PercentageCompleted());
                            $('lblNoResponseComment').hide();
                            $('#mainSurveyResponses').show();
                            ProgressBar();
                            CheckforConditionalQuestions();
                        }
                        else {
                            $('lblNoResponseComment').show();
                            $('#mainSurveyResponses').hide();
                        }
                    }
                    else {
                        logger.logError('An error occurred while fetching the Survey Questions Data. Please contact your Application Administrator.', 'Error', system.getModuleId(RRDashboardVM), true);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess from GetCompleteSurveyData() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    var msg = 'Exception: ' + error + ' | Source: ajaxFail from GetCompleteSurveyData() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail from GetCompleteSurveyData() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region Conditional Questions

        function ConditionQuestionchange(data, event) {
            try {
                var selectedQuestionId = data.QuestionId_QRT();
                var selectedResponseId = data.SavedResponseId();

                for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                    for (var j = 0; j < RRResponseVM.SurveyData()[i].QuestionResponseTypes().length; j++) {
                        var ParentQuestionId = RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].ParentQuestionId_QRT();
                        if (ParentQuestionId !== 0) {
                            if (ParentQuestionId === selectedQuestionId) {
                                var ParentResponses = RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].ParentResponseIds_QRT().split('|');
                                var count = 0;
                                for (var k = 0; k < ParentResponses.length; k++) {
                                    if (selectedResponseId === parseInt(ParentResponses[k].toString().trim()))
                                        count++;
                                }
                                if (count > 0)
                                    RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].IsConditional_QRT(0);
                                else {
                                    RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].IsConditional_QRT(1);
                                    RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].SavedResponseId('');
                                    RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].SavedResponseTextValue('');
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ConditionQuestionchange() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CheckforConditionalQuestions() {
            try {
                for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                    for (var j = 0; j < RRResponseVM.SurveyData()[i].QuestionResponseTypes().length; j++) {

                        var ParentQuestionId = RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].ParentQuestionId_QRT();
                        if (ParentQuestionId !== 0) {

                            for (var l = 0; l < RRResponseVM.SurveyData().length; l++) {
                                for (var m = 0; m < RRResponseVM.SurveyData()[l].QuestionResponseTypes().length; m++) {

                                    var selectedQuestionId = RRResponseVM.SurveyData()[l].QuestionResponseTypes()[m].QuestionId_QRT();
                                    var selectedResponseId = RRResponseVM.SurveyData()[l].QuestionResponseTypes()[m].SavedResponseId();

                                    if (selectedQuestionId === ParentQuestionId) {
                                        var ParentResponses = RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].ParentResponseIds_QRT().split('|');
                                        var count = 0;
                                        for (var k = 0; k < ParentResponses.length; k++) {
                                            if (selectedResponseId === parseInt(ParentResponses[k].toString().trim()))
                                                count++;
                                        }
                                        if (count > 0)
                                            RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].IsConditional_QRT(0);
                                        else {
                                            RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].IsConditional_QRT(1);
                                            RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].SavedResponseId('');
                                            RRResponseVM.SurveyData()[i].QuestionResponseTypes()[j].SavedResponseTextValue('');
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CheckforConditionalQuestions() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Search

        function SearchResult(data, event) {
            try {
                var searchedList = ko.computed(function () {
                    var q = RRResponseVM.SearchQuery();
                    if (q !== "") {
                        return RRResponseVM.SurveyData().filter(function (i) {
                            return i.Question().toLowerCase().indexOf(q.toLowerCase()) >= 0;
                        });
                    }
                });

                for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                    RRResponseVM.SurveyData()[i].VisibilityFlag(0);
                }

                if (RRResponseVM.SearchQuery() !== undefined && RRResponseVM.SearchQuery() === "") {
                    //for empty keyboard input
                    for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                        RRResponseVM.SurveyData()[i].VisibilityFlag(1);
                    }
                }
                if (searchedList() !== undefined) {
                    for (var j = 0; j < searchedList().length; j++) {
                        for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                            if (RRResponseVM.SurveyData()[i].QuestionId() == searchedList()[j].QuestionId()) {
                                RRResponseVM.SurveyData()[i].VisibilityFlag(1);
                            }
                        }
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SearchResult() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ClearSearchText() {
            try {
                $('#searchFeature').val('');
                if (RRResponseVM.SurveyData() !== undefined && RRResponseVM.SurveyData().length > 0) {
                    for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                        RRResponseVM.SurveyData()[i].VisibilityFlag(1);
                    }
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ClearSearchText() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Reset

        function ResetResponse() {
            try {
                $('#QuestionsDiv').hide();
                $('#loadingImgMain').show();
                ClearSearchText();
                GetCompleteSurveyData();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetResponse() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ProgressBar

        function ProgressBar() {
            try {
                var elem = document.getElementById("myBar");
                var width = 0;
                width = width + RRResponseVM.BarWidth();
                elem.style.width = width + '%';
                ko.applyBindings(RRResponseVM, document.getElementById('myBar'));
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ProgressBar() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region SaveSurvey

        function SaveResponse(data, event) {
            try {
                var SurveyObj = ko.toJS(RRResponseVM.SurveyData());
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SetSurveyQuestionnaire",
                    type: "POST",
                    headers: headers,
                    contentType: 'application/json',
                    dataType: 'json',
                    data: JSON.stringify(SurveyObj)
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult === 1) {
                            logger.logSuccess('Responses have been saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                            GetCompleteSurveyData();
                        }
                        else
                            logger.logError('An error occurred while saving the survey resposnes. Please contact your Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option === "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveResponse() method in RiskRatingResponsePage.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveResponse() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Comments

        function GetComments(QuestionId, Type) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/GetRRSurveyComments?SurveyId=" + RRResponseVM.SurveyId() + "&QuestionId=" + QuestionId + "&CommentType=" + Type.toString(),
                    type: "GET",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in GetComments() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status) {
                try {
                    RRResponseVM.CommentsList([]);
                    RRResponseVM.DocumentsList([]);
                    if (jsonResult !== null) {
                        if (jsonResult.length > 0) {

                            var mappedComments = $.map(jsonResult, function (result) {
                                return new CommentsModel(result);
                            });
                            if (Type != "RD")
                                RRResponseVM.CommentsList(mappedComments);
                            else
                                RRResponseVM.DocumentsList(mappedComments);

                            if (Type === "PBC")
                                $('#loadingImgMainFS').hide();
                        }
                        else {
                            if (Type === "PBC") {
                                $('#FSCommentsError').show();
                                $('#loadingImgMainFS').hide();
                            }
                        }
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetComments() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetComments() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetComments() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function SetComments(QuestionId, Type, CommentText) {
            try {
                var CommentId = 0;
                if (RRResponseVM.SelectedCommentId() !== "")
                    CommentId = RRResponseVM.SelectedCommentId();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/SetRRSurveyComments?SurveyId=" + RRResponseVM.SurveyId() + "&QuestionId=" + QuestionId +
                         "&CommentType=" + Type.toString() + "&CommentText=" + CommentText.toString() + "&CommentId=" + CommentId,
                    type: "POST",
                    headers: headers
                })
                    .success(function (jsonResult, success) {
                        if (jsonResult > 0) {
                            if (Type === "RC") {
                            logger.logSuccess('Comments have been saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                                for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                                    if (RRResponseVM.SurveyData()[i].QuestionId() === RRResponseVM.SelectedQuestionId())
                                        RRResponseVM.SurveyData()[i].CommentCount(jsonResult);
                                }
                            }
                            if (Type === "PBC")
                                return true;
                        }
                        else
                            logger.logError('An error occurred while saving the comments. Please contact your Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                    })
                    .fail(function (error, status) {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option === "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetComments() method in RiskRatingResponsePage.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetComments() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region ResponseComments

        function ShowComments(data, event) {
            try {
                CloseCommentsPopOver();
                $('#lblRCError').hide();
                RRResponseVM.SelectedCommentId('');
                RRResponseVM.ResponseComment('');
                RRResponseVM.CommentsList([]);
                RRResponseVM.SelectedQuestion(data);
                RRResponseVM.ResponseCommentChars(RRResponseVM.ResponseCommentCharsLimit());
                var responseTypes = ko.toJS(data.QuestionResponseTypes());
                var mappedRTs = $.map(responseTypes, function (result) {
                    return new ResponseTypesModel(result);
                });
                RRResponseVM.ResponseTypesDropdown(mappedRTs);
                RRResponseVM.SelectedQuestionId(data.QuestionId());

                GetComments(RRResponseVM.SelectedQuestionId(), "RC").then(function () {

                    $('#CommentsDiv_' + data.QuestionId()).html("");
                    $('#CommentsDiv_' + data.QuestionId()).html($('#ResponseCommentPopOverDiv').html());
                    $('#DocumentsDiv_' + data.QuestionId()).html("");

                    $('#CommentsArrowDiv_' + data.QuestionId()).show();
                    $('#DocumentsArrowDiv_' + data.QuestionId()).hide();

                    var element = $('#CommentsKoDiv')[0];
                    ko.cleanNode(element);
                    ko.applyBindings(RRResponseVM, document.getElementById('CommentsKoDiv'));

                    $($($('#CommentsDiv_' + data.QuestionId()).find('#CommentsKoDiv')).find('#RCDiv')).html($('#ResponseCommentsListDiv').html());

                    for (var i = 0; i < RRResponseVM.CommentsList().length; i++) {
                        ko.applyBindingsToNode($('#editCommentbtn_' + RRResponseVM.CommentsList()[i].CommentId()), { click: RRResponseVM.EditComment }, RRResponseVM.CommentsList()[i]);
                    }

                    $('#loadingImgMainRC').hide();
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowComments() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CloseCommentsPopOver() {
            try {
                RRResponseVM.SelectedQuestion('');
                var QuestionId = '';
                if (RRResponseVM.SelectedQuestionId() !== undefined) {
                    QuestionId = RRResponseVM.SelectedQuestionId();
                }
                $('#CommentsDiv_' + QuestionId).html("");
                $('#DocumentsDiv_' + QuestionId).html("");

                $('#CommentsArrowDiv_' + QuestionId).hide();
                $('#DocumentsArrowDiv_' + QuestionId).hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CloseCommentsPopOver() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SaveComment(data) {
            try {
                $('#lblRCError').hide();
                if (RRResponseVM.ResponseComment() === undefined || RRResponseVM.ResponseComment() === "") {
                    $('#lblRCError').show();
                    document.getElementById('lblRCError').innerHTML = "The Response comment can not be left blank.";
                    return false;
                }
                else if (RRResponseVM.ResponseComment().length > RRResponseVM.ResponseCommentCharsLimit()) {
                    $('#lblRCError').show();
                    document.getElementById('lblRCError').innerHTML = "The response comment should not exceed " + RRResponseVM.ResponseCommentCharsLimit() + " characters.";
                    return false;
                }
                else
                    SetComments(RRResponseVM.SelectedQuestionId(), "RC", RRResponseVM.ResponseComment()).then(function () {
                        GetComments(RRResponseVM.SelectedQuestionId(), "RC").then(function () {

                            ResetComment();

                            $($($('#CommentsDiv_' + data.QuestionId()).find('#CommentsKoDiv')).find('#RCDiv')).html("");
                            $($($('#CommentsDiv_' + data.QuestionId()).find('#CommentsKoDiv')).find('#RCDiv')).html($('#ResponseCommentsListDiv').html());

                            for (var i = 0; i < RRResponseVM.CommentsList().length; i++) {
                                ko.applyBindingsToNode($('#editCommentbtn_' + RRResponseVM.CommentsList()[i].CommentId()), { click: RRResponseVM.EditComment }, RRResponseVM.CommentsList()[i]);
                            }
                        });


                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SaveComment() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResetComment() {
            try {
                $('#lblRCError').hide();
                $('#ResponseTextArea').val('');
                RRResponseVM.ResponseComment('');
                RRResponseVM.SelectedCommentId('');
                $('#ResponseId').attr('disabled', false);
                RRResponseVM.ResponseCommentChars(RRResponseVM.ResponseCommentCharsLimit());
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResetComment() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function EditComment(data, event) {
            try {
                $('#ResponseId').attr('disabled', true);
                var commentText = data.CommentText().split(': ')[1];
                RRResponseVM.SelectedCommentId(data.CommentId());
                RRResponseVM.ResponseComment(commentText);
                RRResponseVM.ResponseCommentChars(RRResponseVM.ResponseCommentCharsLimit() - commentText.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: EditComment() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function RcKeypress(data, event) {
            try {
                if (event.which === 16 || event.which === 17 || event.which === 18 || (event.which >= 112 && event.which <= 123) || (event.which >= 35 && event.which <= 40) || event.which === 46 || event.which === 8)
                    return true;
                else {
                    if (event.currentTarget.value.length >= RRResponseVM.ResponseCommentCharsLimit())
                        return false;
                    else
                        return true;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RcKeypress() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function RcKeyUp(data, event) {
            try {
                RRResponseVM.ResponseCommentChars(RRResponseVM.ResponseCommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RcKeyUp() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

        //#region Documents

        function ShowUploadDocumentsPopUp(data, event) {
            try {
                CloseDocumentsPopOver();
                document.getElementById('lblRDError').innerHTML = "";
                RRResponseVM.UploadComment('');
                RRResponseVM.SelectedQuestionId(data.QuestionId());
                RRResponseVM.SelectedQuestionText(data.Question());
                RRResponseVM.IsReadOnlyQuestion(data.IsReadOnly());
                RRResponseVM.QuestionDisplayRank(data.DisplayRank());
                RRResponseVM.UploadDocCommentChars(RRResponseVM.UploadDocCommentCharsLimit());

                GetComments(RRResponseVM.SelectedQuestionId(), "RD").then(function () {

                    $('#CommentsDiv_' + data.QuestionId()).html("");
                    $('#DocumentsDiv_' + data.QuestionId()).html("");
                    $('#DocumentsDiv_' + data.QuestionId()).html($('#UploadDocumentPopUp').html());

                    $('#CommentsArrowDiv_' + data.QuestionId()).hide();
                    $('#DocumentsArrowDiv_' + data.QuestionId()).show();

                    var element = $('#DocumentsKoDiv')[0];
                    ko.cleanNode(element);
                    ko.applyBindings(RRResponseVM, document.getElementById('DocumentsKoDiv'));

                    $($($('#DocumentsDiv_' + data.QuestionId()).find('#DocumentsKoDiv')).find('#RDCommentsDiv')).html($('#RDCommentsListDiv').html());

                    for (var i = 0; i < RRResponseVM.DocumentsList().length; i++) {
                        ko.applyBindingsToNode($('#downloadDocumentbtn_' + RRResponseVM.DocumentsList()[i].CommentId()), { click: RRResponseVM.DownloadDocument }, RRResponseVM.DocumentsList()[i]);
                        ko.applyBindingsToNode($('#deleteDocumentbtn_' + RRResponseVM.DocumentsList()[i].CommentId()), { click: RRResponseVM.DeleteDocument }, RRResponseVM.DocumentsList()[i]);
                    }


                    $('#loadingImgMainRD').hide();
                });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ShowUploadDocumentsPopUp() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CloseDocumentsPopOver() {
            try {
                RRResponseVM.SelectedQuestionText('');
                RRResponseVM.QuestionDisplayRank('');
                RRResponseVM.IsReadOnlyQuestion(0);
                var QuestionId = '';
                if (RRResponseVM.SelectedQuestionId() !== undefined) {
                    QuestionId = RRResponseVM.SelectedQuestionId();
                }
                RRResponseVM.SelectedQuestionId('');
                $('#CommentsDiv_' + QuestionId).html("");
                $('#DocumentsDiv_' + QuestionId).html("");

                $('#CommentsArrowDiv_' + QuestionId).hide();
                $('#DocumentsArrowDiv_' + QuestionId).hide();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CloseDocumentsPopOver() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function UploadDocument() {
                try {
                    var Filelist = "";
                    var FileName = "";
                    var errormsgId = "";
                    var ProgressBarMainDivId = "";
                    var ProgressMsgId = "";
                    errormsgId = "lblRDError";
                    ProgressBarMainDivId = "#ProgressBarMainDiv";
                    ProgressMsgId = "#lblProgressMsg";
                    FileList = document.getElementById('FileUploaderForDocuments').files;
                    if (FileList.length > 0)
                        FileName = document.getElementById('FileUploaderForDocuments').files[0].name;
                  
                    if (FileList.length > 0) {
                        if ((FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PNG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'JPEG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOCX'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'DOC'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLS'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PDF'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'CSV'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'TXT'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'XLSX'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPT'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'PPTX'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'MSG'
                            | FileName.substring(FileName.lastIndexOf('.') + 1, FileName.length).toUpperCase() == 'ZIP'
                        ) && (FileName.split('.').length - 1) == 1) {

                            if (FileList[0].size <= 20145728) {
                                if (RRResponseVM.UploadComment() != "" && RRResponseVM.UploadComment() != undefined) {
                                    if (RRResponseVM.UploadComment().length <= RRResponseVM.UploadDocCommentCharsLimit()) {
                                        document.getElementById(errormsgId).innerHTML = "";
                                        $(ProgressMsgId).removeClass('field-validation-error');
                                        var FormDataObj = new FormData();
                                        FormDataObj.append("File1", FileList[0]);
                                        var request = new XMLHttpRequest();
                                        $(ProgressBarMainDivId).show();
                                        request.onreadystatechange = function () {
                                            if (request.readyState == 1) {
                                                RRResponseVM.ProgressMessage("Initializing File Upload...");
                                            }
                                            else if (request.readyState == 4) {
                                                if (request.status == 200) {
                                                    if (request.responseText != null && request.responseText != "" && request.responseText != "null") {
                                                        RRResponseVM.ProgressMessage("The file has been uploaded successfully.");

                                                        var DocName = "";
                                                        DocName = document.getElementById('FileUploaderForDocuments').files[0].name;
                                                        document.getElementById('FileUploaderForDocuments').value = null;

                                                        SetDocumentComments(RRResponseVM.SelectedQuestionId(), "RD", DocName, JSON.parse(request.response), RRResponseVM.UploadComment()).then(function () {

                                                            GetComments(RRResponseVM.SelectedQuestionId(), "RD").then(function () {

                                                                $($($('#DocumentsDiv_' + RRResponseVM.SelectedQuestionId()).find('#DocumentsKoDiv')).find('#RDCommentsDiv')).html("");
                                                                $($($('#DocumentsDiv_' + RRResponseVM.SelectedQuestionId()).find('#DocumentsKoDiv')).find('#RDCommentsDiv')).html($('#RDCommentsListDiv').html());

                                                                for (var i = 0; i < RRResponseVM.DocumentsList().length; i++) {
                                                                    ko.applyBindingsToNode($('#downloadDocumentbtn_' + RRResponseVM.DocumentsList()[i].CommentId()), { click: RRResponseVM.DownloadDocument }, RRResponseVM.DocumentsList()[i]);
                                                                    ko.applyBindingsToNode($('#deleteDocumentbtn_' + RRResponseVM.DocumentsList()[i].CommentId()), { click: RRResponseVM.DeleteDocument }, RRResponseVM.DocumentsList()[i]);
                                                                }

                                                            });
                                                            document.getElementById('UploadTextArea').value = '';
                                                        });

                                                        RRResponseVM.UploadComment("");
                                                    }
                                                    else {
                                                        $(ProgressMsgId).addClass('field-validation-error');
                                                        RRResponseVM.ProgressMessage("The file could not be uploaded.");
                                                        document.getElementById('FileUploaderForDocuments').value = null;
                                                    }
                                                }
                                            }
                                            else
                                                ajaxFail(request, "");

                                        };
                                        request.upload.addEventListener('progress', function (event) {
                                            RRResponseVM.ProgressPercent(parseInt((event.loaded / event.total) * 100) + '%');
                                            RRResponseVM.ProgressMessage("Uploading File...");
                                        });
                                        request.withCredentials = true;
                                        var csrfToken = $("input[name='__RequestVerificationToken']").val();
                                        var headers = appsecurity.getSecurityHeaders();
                                        headers.__RequestVerificationToken = csrfToken;
                                        request.open('POST', '/api/Survey/FileUpload');
                                        request.setRequestHeader('Authorization', headers.Authorization);
                                        request.setRequestHeader('RT', headers.RT);
                                        request.setRequestHeader('__RequestVerificationToken', headers.__RequestVerificationToken);
                                        request.send(FormDataObj);
                                        logger.logMessage("The file has been uploaded successfully.");

                                    }
                                    else
                                        document.getElementById(errormsgId).innerHTML = "Upload Comment cannot exceed " + RRResponseVM.UploadDocCommentCharsLimit() + " characters.";
                                }
                                else
                                    document.getElementById(errormsgId).innerHTML = "Please enter some comment related to the uploaded file.";
                            }
                            else
                                document.getElementById(errormsgId).innerHTML = "Upload file size cannot exceed " + (RRResponseVM.UploadFileSize() / 1048576) + " MB. Please try uploading a file of lesser size.";
                        }
                        else {
                            document.getElementById(errormsgId).innerHTML = "Please select a valid file to upload.";
                        }
                    }

                    else
                        document.getElementById(errormsgId).innerHTML = "Please select a file to upload.";


                    function ajaxFail(error, status) {

                        try {
                            if (error.status == 401) {
                                app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                    .then(function (option) {
                                        if (option == "OK")
                                            router.navigate("#RiskRating/RiskRatingDashboard", true);

                                    })
                            }
                            else {
                                var msg = 'Exception: ' + error.responseText + ' | Source: ajaxFail in UploadDocuments() method in RiskRatingResponsePage.js';
                                logger.logMessage(msg);
                            }
                        } catch (e) {
                            var msg = 'Exception: ' + e + ' | Source: ajaxFail in UploadDocuments() method in RiskRatingResponsePage.js';
                            logger.logMessage(msg);
                        }
                    };

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: UploadDocument() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function RdKeypress(data, event) {
            try {
                if (event.which === 16 || event.which === 17 || event.which === 18 || (event.which >= 112 && event.which <= 123) || (event.which >= 35 && event.which <= 40) || event.which === 46 || event.which === 8)
                    return true;
                else {
                    if (event.currentTarget.value.length >= RRResponseVM.UploadDocCommentCharsLimit())
                        return false;
                    else
                        return true;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RdKeypress() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function RdKeyUp(data, event) {
            try {
                RRResponseVM.UploadDocCommentChars(RRResponseVM.UploadDocCommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: RdKeyUp() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SetDocumentComments(QuestionId, Type, DocName, DocPath, CommentText) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                return $.ajax({
                    url: "/api/RiskRatingDashboard/SetDocumentComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        QuestionId: QuestionId, SPR_UID: RRResponseVM.SurveyId(), CommentType: "RD", CommentText: CommentText, DocumentPath: DocPath, DocumentName: DocName,
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(function (jsonResult, error) {
                        if (jsonResult > 0) {
                            logger.logSuccess('Document has been saved successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                            for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                                if (RRResponseVM.SurveyData()[i].QuestionId() === QuestionId)
                                    RRResponseVM.SurveyData()[i].DocumentCount(jsonResult);
                            }
                        }
                        else {
                            logger.logError('An error occurred while uploading the document.', 'Error', system.getModuleId(RRResponseVM), true);
                        }
                    })
                    .fail(function (error, status) {
                        if (error.status === 401) {
                            app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                                .then(function (option) {
                                    if (option === "OK") {
                                        navigation.unauthorized();
                                    }
                                });
                        } else {
                            var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SetDocumentComments() method in RiskRatingResponsePage.js';
                            logger.logMessage(msg);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SetDocumentComments() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function DownloadDocument(data, event) {
            try {
                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Survey/CheckFilePresence",
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders(),
                    data: { CommentId: data.CommentId(), FilePath: data.DocumentPath(), FileName: data.DocumentName() }
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DownloadDocument() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {

                    if (jsonResult) {
                        var payLoad = {
                            t: appsecurity.getAuthenticationInfo(), FilePath: data.DocumentPath(), FileName: data.DocumentName()
                        };
                        utils.postAndRedirect(rootPath + "/FileDownload/DownloadFile", payLoad, '_blank');
                    }
                    else
                        logger.logError('The requested document is not available for download. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DownloadDocument() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DownloadDocument() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DownloadDocument() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }

        function DeleteDocument(data, event) {
            try {
                app.showMessage('Are you sure you want to delete this document?', 'Delete Document', ['Confirm', 'Cancel'])
                    .then(function (option) {
                        if (option === 'Confirm') {
                            DeleteResponseDocument(data);
                        }
                    });
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: DeleteDocument() method in AMLControlAreaSetup.js';
                logger.logMessage(msg);
            }
        }

        function DeleteResponseDocument(data) {
            try {

                var DocumentInfo = data;
                var test = $.ajax({
                    url: "/api/Survey/CheckFilePresence?CommentId=" + data.CommentId() + "&FileName=" + data.DocumentName() + "&FilePath=" + data.DocumentPath(),
                    type: "Get",
                    headers: appsecurity.getSecurityHeaders()
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail)
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxCall in DeleteResponseDocument() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, status, xhr) {
                try {
                    if (jsonResult) {
                        DeleteDocComments(data);
                    }
                    else
                        logger.logError('The requested document is not available to delete. Please contact your Application Administrator.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteResponseDocument() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }



            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteResponseDocument() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteResponseDocument() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            };

        }


        function DeleteDocComments(data) {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteDocComments",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        CommentId: data.CommentId(),
                        QuestionId: RRResponseVM.SelectedQuestionId()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in RiskRatingDashboard.js'
                logger.logMessage(msg);
            }
            function ajaxSuccess(result, status) {
                try {

                    if (result >= 0) {
                        DeleteFile(data);
                    }
                    else
                        logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in RiskRatingResponsePage.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function DeleteFile(data) {
            try {

                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Survey/DeleteFile",
                    dataType: "json",
                    contentType: "application/json; charset=utf-8",
                    data: ko.toJSON({
                        DocumentPath: data.DocumentPath(),
                        DocumentName: data.DocumentName()
                    }),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);

            }
            catch (e) {
                var msg = 'Exception' + e + ' | Source | DeleteDocComments() in RiskRatingDashboard.js'
                logger.logMessage(msg);
            }

            function ajaxSuccess(result, status) {
                try {
                    if (result.toLowerCase() == 'ok') {
                        logger.logSuccess('Document deleted successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                        $('#UploadDocumentPopUp').modal('hide');
                        $('body').removeClass('modal-open');
                        $('.modal-backdrop').remove();
                        for (var i = 0; i < RRResponseVM.SurveyData().length; i++) {
                            if (RRResponseVM.SurveyData()[i].QuestionId() === RRResponseVM.SelectedQuestionId())
                                RRResponseVM.SurveyData()[i].DocumentCount(RRResponseVM.SurveyData()[i].DocumentCount() - 1);
                        }
                        RRResponseVM.DocumentsList.remove(function (item) { return item.CommentId() == data.CommentId() });


                        $($($('#DocumentsDiv_' + RRResponseVM.SelectedQuestionId()).find('#DocumentsKoDiv')).find('#RDCommentsDiv')).html("");
                        $($($('#DocumentsDiv_' + RRResponseVM.SelectedQuestionId()).find('#DocumentsKoDiv')).find('#RDCommentsDiv')).html($('#RDCommentsListDiv').html());

                        for (var i = 0; i < RRResponseVM.DocumentsList().length; i++) {
                            ko.applyBindingsToNode($('#downloadDocumentbtn_' + RRResponseVM.DocumentsList()[i].CommentId()), { click: RRResponseVM.DownloadDocument }, RRResponseVM.DocumentsList()[i]);
                            ko.applyBindingsToNode($('#deleteDocumentbtn_' + RRResponseVM.DocumentsList()[i].CommentId()), { click: RRResponseVM.DeleteDocument }, RRResponseVM.DocumentsList()[i]);
                        }

                    }
                    else
                        logger.logError('An error occurred while deleting the document.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception' + e + ' | Source | ajaxSuccess in DeleteDocComments() in RiskRatingResponsePage.js'
                    logger.logMessage(msg);
                }
            }
            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteDocComments() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteDocComments() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

        }

        //#endregion

        //#region FinalizeSurvey

        function FinalizeSurveyClick() {
            try {
                RRResponseVM.PushbackCommentChars(RRResponseVM.PushbackCommentCharsLimit());
                RRResponseVM.CommentsList([]);
                $('#PushbackTextArea').val('');
                RRResponseVM.PushbackComment('');
                ValidateSurvey();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: FinalizeSurveyClick() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ValidateSurvey() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/ValidateRRSurvey?SurveyId=" + RRResponseVM.SurveyId(),
                    type: "GET",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ValidateSurvey() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    GetSurveyActions();
                    $('#RRFinalizeSurveyPopup').modal('show');
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in ValidateSurvey() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in ValidateSurvey() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in ValidateSurvey() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function GetSurveyActions() {
            try {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/GetActionsList?TableType=" + RRResponseVM.RiskRatingDashboard.ResponseMoveArray().SurveyType() +
                        "&TableId=" + RRResponseVM.SurveyId() + "&RoleId=" + RRResponseVM.RoleId(),
                    type: "GET",
                    headers: headers
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: GetSurveyActions() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }

            function ajaxSuccess(jsonResult, error) {
                try {
                    $('#RRdivActionError').hide();
                    $('#RRActionsMain').show();
                    RRResponseVM.SurveyActionsList([]);
                    if (jsonResult !== null) {
                        var mappedActionsList = $.map(jsonResult, function (result) {
                            return new SurveyActionsModel(result);
                        });
                        RRResponseVM.SurveyActionsList(mappedActionsList);
                    }
                    GetComments(null, "PBC");
                    $('#loadingImgMainFS').show();
                    $('#FSCommentsError').hide();
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetSurveyActions() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetSurveyActions() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetSurveyActions() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        function PbcKeypress(data, event) {
            try {
                if (event.which === 16 || event.which === 17 || event.which === 18 || (event.which >= 112 && event.which <= 123) || event.which === 35 || event.which === 36 || event.which === 46 || event.which === 8)
                    return true;
                else {
                    if (event.currentTarget.value.length >= RRResponseVM.PushbackCommentCharsLimit())
                        return false;
                    else
                        return true;
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PbcKeypress() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function PbcKeyUp(data, event) {
            try {
                RRResponseVM.PushbackCommentChars(RRResponseVM.PushbackCommentCharsLimit() - event.currentTarget.value.length);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: PbcKeyUp() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function btnClickPerformAction(data, event) {
            try {
                if ($('input[name=rdbAction]:checked').val() === undefined) {
                    document.getElementById('RRlblActionError').innerHTML = "Please select an action to perform.";
                    $('#RRdivActionError').show();
                    return false;
                }
                else if (RRResponseVM.PushbackComment() === "" || RRResponseVM.PushbackComment() === undefined) {
                    document.getElementById('RRlblActionError').innerHTML = "Please enter some survey comment.";
                    $('#RRdivActionError').show();
                    return false;
                }
                else if (RRResponseVM.PushbackComment().length > RRResponseVM.PushbackCommentCharsLimit()) {
                    document.getElementById('RRlblActionError').innerHTML = "You cannot enter more than " + RRResponseVM.PushbackCommentCharsLimit() + " characters.";
                    $('#RRdivActionError').show();
                    return false;
                }
                else {
                    $('#RRdivActionError').hide();
                    $('#loadingImgMainFS').show();
                    SetComments(0, "PBC", RRResponseVM.PushbackComment()).then(function () {
                        PerformSurveyAction();
                    });
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: btnClickPerformAction() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function PerformSurveyAction() {
            try {
                $('#loadingImgMainFS').show();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/RiskRatingDashboard/SetPerformAction?EventId=" + $('input[name=rdbAction]:checked').val() +
                        "&SurveyId=" + RRResponseVM.SurveyId() + "&SurveyType=" + RRResponseVM.RiskRatingDashboard.ResponseMoveArray().SurveyType(),
                    headers: headers,
                    type: "POST"
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajax call in PerformSurveyAction() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
            function ajaxSuccess(jsonResult, status) {
                try {
                    $('#loadingImgMainFS').hide();
                    $('#RRFinalizeSurveyPopup').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (jsonResult === 1) {
                        logger.logSuccess('Survey action performed successfully.', 'Success', system.getModuleId(RRResponseVM), true);
                        setTimeout(router.navigate('#RiskRating/RiskRatingDashboard', true), 200);
                    }
                    else
                        logger.logError('An error occurred while performing selected survey action.', 'Error', system.getModuleId(RRResponseVM), true);
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in PerformSurveyAction() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }

            function ajaxFail(error, status) {
                try {
                    $('#loadingImgMainFS').hide();
                    $('#RRFinalizeSurveyPopup').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                    if (error.status === 401) {
                        app.showMessage("You have been logged out. Please login again to complete the operation.", "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option === "OK")
                                    navigation.unauthorized();
                            });
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in PerformSurveyAction() method in RiskRatingResponsePage.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail in PerformSurveyAction() method in RiskRatingResponsePage.js';
                    logger.logMessage(msg);
                }
            }
        }

        //#endregion

        //#region ModelDefinitions

        function SurveyQuestionnaireModel(item) {
            try {
                var self = this;
                self.QuestionId = ko.observable(item.QuestionId);
                self.FactorId = ko.observable(item.FactorId);
                self.RRItemId = ko.observable(item.FactorId);
                self.Question = ko.observable(item.Question);
                self.RRItemName = ko.observable(item.RRItemName);
                self.CommentCount = ko.observable(item.CommentCount);
                self.DocumentCount = ko.observable(item.DocumentCount);
                self.IsConditional = ko.observable(item.IsConditional);
                self.IsHeader = ko.observable(item.IsHeader);
                self.IsReadOnly = ko.observable(item.IsReadOnly);
                self.ParentQuestionId = ko.observable(item.ParentQuestionId);
                self.ParentResponseIds = ko.observable(item.ParentResponseIds);
                self.ParentRATs = ko.observable(item.ParentRATs);
                self.VisibilityFlag = ko.observable(item.VisibilityFlag);
                self.IsResponseMandatory = ko.observable(item.IsResponseMandatory);
                self.IsCommentMandatory = ko.observable(item.IsCommentMandatory);
                self.IsDocumentMandatory = ko.observable(item.IsDocumentMandatory);
                self.IsMultiSelect = ko.observable(item.IsMultiSelect);
                self.Rank = ko.observable(item.Rank);
                self.DisplayRank = ko.observable(item.DisplayRank);
                self.FactorOverallRank = ko.observable(item.FactorOverallRank);
                self.ItemOverallRank = ko.observable(item.ItemOverallRank);
                self.IndentationValue = ko.observable(item.IndentationValue + "rem");
                var mappedQRT = $.map(item.QuestionResponseTypes, function (result) {
                    return new QuestionResponseTypeModel(result);
                });
                self.QuestionResponseTypes = ko.observable(mappedQRT);
                self.PercentageCompleted = ko.observable(item.PercentageCompleted);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyQuestionnaireModel() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QuestionResponseTypeModel(item) {
            try {
                var self = this;
                self.QuestionId_QRT = ko.observable(item.QuestionId_QRT);
                self.ResponseTypeId = ko.observable(item.ResponseTypeId);
                self.ResponseType = ko.observable(item.ResponseType);
                self.SavedResponseId = ko.observable(item.SavedResponseId);
                self.SavedResponseTextValue = ko.observable(item.SavedResponseTextValue);
                self.QRTApplicability = ko.observable(item.QRTApplicability);
                self.IsConditional_QRT = ko.observable(item.IsConditional_QRT);
                self.IsReadOnly_QRT = ko.observable(item.IsReadOnly_QRT);
                self.ParentQuestionId_QRT = ko.observable(item.ParentQuestionId_QRT);
                self.ParentResponseIds_QRT = ko.observable(item.ParentResponseIds_QRT);
                var mappedQR = $.map(item.ResponseList, function (result) {
                    return new QuestionResponseModel(result);
                });
                self.FactorId_QRT = ko.observable(item.FactorId_QRT);
                self.ResponseList = ko.observable(mappedQR);
                self.UniqueResponseId = ko.observable(item.QuestionId_QRT + '_' + item.ResponseTypeId);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuestionResponseTypeModel() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function QuestionResponseModel(item) {
            try {
                var self = this;
                self.QuestionId_QR = ko.observable(item.QuestionId_QR);
                self.ResponseTypeId_QR = ko.observable(item.ResponseTypeId_QR);
                self.ResponseId = ko.observable(item.ResponseId);
                self.ResponseText = ko.observable(item.ResponseText);
                self.CalculationApplicability = ko.observable(item.CalculationApplicability);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: QuestionResponseModel() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function SurveyActionsModel(item) {
            try {
                var self = this;
                self.EventId = ko.observable(item.EventId);
                self.EventName = ko.observable($('<div/>').html(item.EventName).text());
                self.NextState = ko.observable($('<div/>').html(item.NextState).text());
                self.ShowValidatePopup = ko.observable(item.ShowValidatePopup);
                self.IsMessage = ko.observable(item.IsMessage);

            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: SurveyActionsModel() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function CommentsModel(item) {
            try {
                var self = this;
                self.CommentId = ko.observable(item.CommentId);
                self.CommentText = ko.observable($('<div/>').html(item.CommentText).text());
                self.UploadedBy = ko.observable(item.UploadedBy);
                self.UploadedDate = ko.observable(item.UploadedDate);
                self.IsCurrentUser = ko.observable(item.IsCurrentUser);
                self.DocumentPath = ko.observable(item.DocumentPath);
                self.DocumentName = ko.observable(item.DocumentName);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: CommentsModel() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        function ResponseTypesModel(item) {
            try {
                var self = this;
                self.ResponseTypeId = ko.observable(item.ResponseTypeId);
                self.ResponseType = ko.observable(item.ResponseType);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ResponseTypesModel() method in RiskRatingResponsePage.js';
                logger.logMessage(msg);
            }
        }

        //#endregion

    });
